import React, { useMemo } from 'react';
import { AuthContext, LayoutContext } from 'contexts';
import { Affix, theme } from 'components';
import { useBreakpoint } from 'hooks';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import { Color } from '@bb/elements-web-rebranding';
import BBAssumeNavbar from './BBAssumeNavbar';
import AnsweringAssumeNavbar from './AnsweringAssumeNavbar';
import { StyledContent } from './StyledComponents';

// used to prevent body scroll in TourEditPage/hooks/useFixMobile
export const ASSUME_BAR_ID = 'bb-assume-bar-container';

const AssumeNavbar: React.FC = () => {
  const { auth, isBrokerBay } = React.useContext(AuthContext);
  const { topElementHeights, transition } = React.useContext(LayoutContext);
  const { md } = useBreakpoint();
  const isAssumedNotBB = auth?.isAssumedNotBB || auth?.assumerIdMlsStaff;

  const $color = useMemo(() => {
    if (!isBrokerBay) return theme.red6;
    if (featureEnabled('supraRebrandingFeature', 1)) return Color.PRIMARY;
    return theme.getColor('primary');
  }, [isBrokerBay]);
  const height = topElementHeights.bbAssume + topElementHeights.answeringAssume;

  const anchorRef = React.useRef<HTMLDivElement>(null);

  if (isBrokerBay || isAssumedNotBB) {
    return (
      <Affix
        offsetTop={0}
        style={{
          height,
          transition: `height ${transition}s`,
          position: 'fixed',
          zIndex: 1010,
        }}
      >
        <div id={ASSUME_BAR_ID}>
          <StyledContent
            $md={md}
            $height={height}
            $transition={transition}
            $color={$color}
          >
            {isBrokerBay && <BBAssumeNavbar anchorRef={anchorRef} />}
            {isAssumedNotBB && <AnsweringAssumeNavbar />}
          </StyledContent>
          <StyledAnchor ref={anchorRef} />
        </div>
      </Affix>
    );
  }

  return null;
};

const StyledAnchor = styled.div`
  position: relative;
`;

export default AssumeNavbar;
